module.exports = __webpack_public_path__ + "static/media/NeritoHome2.8499d294.png";